import React, { useState } from 'react';
import api from '../lib/api';
import { useAuth } from '../hooks/useAuth';
import toast from 'react-hot-toast';

export default function ProfilePage() {
  const { user, refreshUser } = useAuth();
  const [form, setForm]   = useState({ full_name: user?.full_name || '', company: user?.company || '', phone: user?.phone || '' });
  const [saving, setSaving] = useState(false);
  const [passForm, setPassForm] = useState({ current_password: '', new_password: '' });
  const [changingPass, setChangingPass] = useState(false);

  const saveProfile = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put('/auth/profile', form);
      await refreshUser();
      toast.success('Profile updated');
    } catch (err) { toast.error(err.message); }
    finally { setSaving(false); }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    if (passForm.new_password.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    setChangingPass(true);
    try {
      await api.put('/auth/password', passForm);
      toast.success('Password updated');
      setPassForm({ current_password: '', new_password: '' });
    } catch (err) { toast.error(err.message); }
    finally { setChangingPass(false); }
  };

  const roleColors = { admin: '#ef4444', tech: '#3b82f6', client: '#6b7280' };

  return (
    <div>
      <div className="page-header"><h2>Profile</h2></div>
      <div className="page-body">
        <div style={{ maxWidth: 560, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div className="card card-lg">
            <div className="flex items-center gap-4" style={{ marginBottom: 24 }}>
              <div className="avatar" style={{ width: 56, height: 56, fontSize: 20 }}>
                {(user?.full_name || user?.email || '?').slice(0, 1).toUpperCase()}
              </div>
              <div>
                <h3 style={{ fontSize: 17 }}>{user?.full_name || 'No name set'}</h3>
                <div className="text-muted text-sm">{user?.email}</div>
                <span className="badge" style={{ marginTop: 4, background: roleColors[user?.role] + '18', color: roleColors[user?.role], textTransform: 'capitalize' }}>{user?.role}</span>
              </div>
            </div>
            <form onSubmit={saveProfile}>
              <div className="form-group"><label className="form-label">Full name</label><input className="form-input" value={form.full_name} onChange={e => setForm(f => ({ ...f, full_name: e.target.value }))} /></div>
              <div className="form-group"><label className="form-label">Company</label><input className="form-input" value={form.company} onChange={e => setForm(f => ({ ...f, company: e.target.value }))} placeholder="Your company name" /></div>
              <div className="form-group"><label className="form-label">Phone</label><input className="form-input" value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} placeholder="(555) 555-5555" /></div>
              <div style={{ textAlign: 'right' }}><button className="btn btn-primary" disabled={saving}>{saving ? 'Saving…' : 'Save Changes'}</button></div>
            </form>
          </div>

          <div className="card card-lg">
            <h3 style={{ fontSize: 14, marginBottom: 16 }}>Change Password</h3>
            <form onSubmit={changePassword}>
              <div className="form-group"><label className="form-label">Current password</label><input className="form-input" type="password" value={passForm.current_password} onChange={e => setPassForm(f => ({ ...f, current_password: e.target.value }))} /></div>
              <div className="form-group"><label className="form-label">New password</label><input className="form-input" type="password" value={passForm.new_password} onChange={e => setPassForm(f => ({ ...f, new_password: e.target.value }))} placeholder="Min 6 characters" /></div>
              <div style={{ textAlign: 'right' }}><button className="btn btn-secondary" disabled={changingPass || !passForm.new_password}>{changingPass ? 'Updating…' : 'Update Password'}</button></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
